import { defineComponent as _defineComponent } from 'vue'
import { formatDate } from '@/util/global';
import NDrawer from '@/component/NDrawer/NDrawer.vue';
import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import NSchedule, { ScheduleProps } from '@/component/NSchedule/NSchedule.vue';
import ViewImg from '@/component/ViewImg/ViewImg.vue';
import { getOrderDetail, getOrderLog, setOrderLog } from '@/api/order/order-list';
import OrderOperation from './components/OrderOperation.vue';
import OrderLogistics from './components/OrderLogistics.vue';
import ModalItem from '@/component/ModalItem/ModalItem.vue';

import { useRouter } from '@/router';
import moment from 'moment';

export default /*#__PURE__*/_defineComponent({
  __name: 'PalatsOrderDetails',
  props: {
    id: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as {
  id: number;
};

const router = useRouter();
const isChange = ref(false);

const detail = ref<any>({});

const visible = ref<boolean>(false);
const steps = computed<ScheduleProps['status']>(() => {
  const { paid_time = 0, express_time = 0, status } = detail.value;
  const confirmed_time = status == 3 ? 0 : detail.value.confirmed_time;
  return [
    {
      title: `${paid_time ? '已' : '待'}支付`,
      date: paid_time ? formatDate(paid_time) : '',
      isOpen: detail.value?.status == 1 || paid_time,
    },
    {
      title: `${express_time ? '已' : '待'}发货`,
      date: express_time ? formatDate(express_time) : '',
      isOpen: express_time,
    },
    {
      title: `${confirmed_time ? '已' : '待'}收货`,
      date: confirmed_time ? formatDate(confirmed_time) : '',
      isOpen: confirmed_time,
    },
  ];
});
function onClose() {
  clearInterval(time);
  visible.value = false;
  if (isChange.value) {
    emit('change');
  }
  if (router.currentRoute.name) {
    router.push({
      name: router.currentRoute.name,
    });
  }
}

const now = ref(0);
const remaining = computed(() => {
  const t = moment.duration(detail.value.pay_deadline_time - now.value, 'seconds');
  const hours = t.hours();
  const minutes = t.minutes();
  const seconds = t.seconds();
  return moment({ h: hours, m: minutes, s: seconds }).format('HH:mm:ss');
});
let time = undefined as any;
async function onOpen() {
  clearInterval(time);
  time = setInterval(() => {
    now.value = moment().unix();
  }, 10);

  if (router.currentRoute.name) {
    router.push({
      name: router.currentRoute.name,
      query: {
        order_id: String(props.id),
      },
    });
  }
  visible.value = true;
  if (props.id) {
    getFollow(props.id);
    const res = await getOrderDetail(props.id);
    if (!res) {
      return;
    }
    detail.value = res;
  }
}
async function getFollow(id) {
  followLoading.value = true;
  const res = await getOrderLog(id);
  followLoading.value = false;
  if (res.detail) {
    follow.value = res.detail;
  }
}
const follow = ref<any[]>([]);
const followInfo = ref<any>('');
const followLoading = ref<boolean>(false);

function addFollow() {
  if (!followInfo.value) {
    return;
  }
  followLoading.value = true;
  setOrderLog(props.id, followInfo.value).then(() => {
    followInfo.value = '';
    followLoading.value = false;
    onOpen();
  });
  onOpen();
}

const drawerRef = ref();
onMounted(() => {
  // 处理ant表格操作列导致的多次渲染bug
  const _this = getCurrentInstance();
  if (_this) {
    //判断当前节点的父级是否是ant table产生的虚拟节点，如果是则移除该组件
    for (const className of _this?.proxy?.$parent?.$el.classList || []) {
      if (className == 'ant-table-fixed-columns-in-body') {
        _this?.proxy?.$parent?.$el?.remove();
        getCurrentInstance()?.proxy?.$destroy();
        return;
      }
    }
  }

  if (router.currentRoute.query) {
    const order_id = String(router.currentRoute.query.order_id);
    if (order_id == String(props.id)) {
      drawerRef.value.open();
      console.log('打开');
    }
  }
});

return { __sfc: true,router, isChange, props, detail, emit, visible, steps, onClose, now, remaining, time, onOpen, getFollow, follow, followInfo, followLoading, addFollow, drawerRef, formatDate, NDrawer, NSchedule, ViewImg, OrderOperation, OrderLogistics, ModalItem }
}

})